import React, { useEffect, useState } from 'react'
import DateConverter from '../Tools/DateConverter'
import MsgUtils from '../Tools/MsgUtils';
import { startOfWeek, addWeeks, getISOWeek } from 'date-fns'
import ItemProyeccionDay from './ItemProyeccionDay';
const productos = [{ 'ID': -3, 'PRODUCTO': 'POLLO' }, { 'ID': 187, 'PRODUCTO': 'PIPOCAS' }, { 'ID': 121, 'PRODUCTO': 'ARROZ' },
    { 'ID': 122, 'PRODUCTO': 'ARROZ FRIJOL' }, { 'ID': 158, 'PRODUCTO': 'JUGO MARACUYA' }, { 'ID': 159, 'PRODUCTO': 'JUGO MANGO' },
    { 'ID': 160, 'PRODUCTO': 'JUGO FRUTILLA' }]
const server = process.env.REACT_APP_SERVER;
function ReporteProyeccionDiaria() {
    const [fecha, setFecha] = useState(DateConverter.getFechFuturaFormatoDefault(true));
    const [listaSucursales, setListaSucursales] = useState([]);
    const [idProducto,setIdProducto] =useState(0);
    function getNumSemanaHoy() {
        var fechaHoy = new Date()
        return getISOWeek(fechaHoy)
    }
    function getSucursales() {
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: "990"
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setListaSucursales(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => console.log(err));
    }
    useEffect(() => {
        getSucursales()
        console.log(getNumSemanaHoy())
    }, [])
    return (
        <>
            <div className='bg-dark bg-gradient text-light py-1 container-fluid'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ minWidth: '170px', maxWidth: '170px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light" style={{ border: 'none' }}>{DateConverter.getFechFuturaFormatoDefault(false)}</span>
                            <input type='date' className='form-control' value={fecha} disabled></input>
                        </div>
                    </div>
                    <div className='col' style={{ minWidth: '250px', maxWidth: '250px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light" style={{ border: 'none' }}>Producto</span>
                            <select className="form-select" 
                                defaultValue={idProducto} onChange={(e)=>setIdProducto(e.target.value)}>
                                <option value={0}>Ninguno</option>
                                {productos.map((item, index) => {
                                    return (
                                        <option value={item.ID} key={index}>{item.PRODUCTO}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-group">
                <div className="card bg-dark">
                    <div className='card-header text-center text-light'>
                        SUCURSAL
                    </div>
                    <div className="card-body m-0 p-0">
                        <ul className="list-group">
                            {listaSucursales.map((item, index) => {
                                return (
                                    <li className="list-group-item bg-dark text-light bg-gradient" key={index}>{item.SUCURSAL}</li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
                <div className="card bg-dark">
                    <div className='card-header text-center text-light'>
                        MAÑANA
                    </div>
                    <div className="card-body m-0 p-0">
                        <ItemProyeccionDay sucursales={listaSucursales} fecha={fecha} compl={0} idProducto={idProducto}/>
                    </div>
                </div>
                <div className="card bg-dark">
                    <div className='card-header text-center text-light'>
                        1 SEM
                    </div>
                    <div className="card-body m-0 p-0">
                        <ItemProyeccionDay sucursales={listaSucursales} fecha={fecha} compl={1} idProducto={idProducto} />
                    </div>
                </div>
                <div className="card bg-dark">
                    <div className='card-header text-center text-light'>
                        2 SEM
                    </div>
                    <div className="card-body m-0 p-0">
                        <ItemProyeccionDay sucursales={listaSucursales} fecha={fecha} compl={2} idProducto={idProducto}/>
                    </div>
                </div>
                <div className="card bg-dark">
                    <div className='card-header text-center text-light'>
                        3 SEM
                    </div>
                    <div className="card-body m-0 p-0">
                        <ItemProyeccionDay sucursales={listaSucursales} fecha={fecha} compl={3} idProducto={idProducto}/>
                    </div>
                </div>
                <div className="card bg-dark">
                    <div className='card-header text-center text-light'>
                        4 SEM
                    </div>
                    <div className="card-body m-0 p-0">
                        <ItemProyeccionDay sucursales={listaSucursales} fecha={fecha} compl={4} idProducto={idProducto}/>
                    </div>
                </div>
                <div className="card bg-dark">
                    <div className='card-header text-center text-light'>
                        1 AÑO
                    </div>
                    <div className="card-body m-0 p-0">
                        <ItemProyeccionDay sucursales={listaSucursales} fecha={fecha} compl={52} idProducto={idProducto}/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReporteProyeccionDiaria